import { graphql } from '@api/mesa'

export const GET_ACTIVE_MORTGAGE_LEADS = graphql(`
  query getMortgageLeads {
    getMortgageLeads {
      id
      status
      type
      createdAt
    }
  }
`)

export const GET_MESA_HOME_ENROLLMENT = graphql(`
  query getMesaHomeEnrollment {
    mesaHomeEnrollment {
      isEnrolled
      recognizedMortgageAmount
      awardSource
      canUserEditAwardAmount
      statementSpend
      statementSpendRemaining
      statementCloseDate
      errorDisplayMessage
    }
  }
`)
